// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetBuilderSuggestsRequest,
  TGetBuilderSuggestsModel,
  IMappers,
  TGetBuilderSuggestsResponse,
  IGetBuilderSuggestsResponse,
  IGetBuilderSuggestsResponseError,
} from './types';

export const defaultConfig: TGetBuilderSuggestsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'countryside-search',
  pathApi: '/v1/get-builder-suggests/',
} as TGetBuilderSuggestsModel;

export function createGetBuilderSuggestsModel(parameters: IGetBuilderSuggestsRequest): TGetBuilderSuggestsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetBuilderSuggestsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetBuilderSuggestsRequest;
}

export async function fetchGetBuilderSuggests<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetBuilderSuggestsOptions<TResponse200, TResponse400>): Promise<
  TGetBuilderSuggestsResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetBuilderSuggestsModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetBuilderSuggestsResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetBuilderSuggestsResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetBuilderSuggestsResponse;
}
